import React, { useEffect, useState } from "react";
import NoticiaSwiper from "./components/NoticiaSwiper";
import api from "../Services/api";
import "./Noticias.css";

interface NoticiaData {
  ID: number;
  Title: string;
  Descricao: string;
  Categoria?: {
    Title: string;
  };
  DataInicio: string;
  UrlIcone: string;
}

const Noticias: React.FC<{ url: string }> = ({ url }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [noticias, setNoticias] = useState<NoticiaData[]>([]);
  const [swiperIndex, setSwiperIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      const ismobile = window.innerWidth < 768;
      if (ismobile !== isMobile) setIsMobile(ismobile);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isMobile]);

  useEffect(() => {
    const fetchNoticias = async () => {
      try {
        setIsLoading(true);
        const response = await api.get(url);
        setNoticias(response.data.results || []);
      } catch (error) {
        console.error("Erro ao carregar notícias:", error);
        setNoticias([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchNoticias();
  }, [url]);

  if (isLoading) {
    return (
      <section className="noticias-container">
        <div className="noticias-loading">
          <p>Carregando notícias...</p>
        </div>
      </section>
    );
  }

  return (
    <section className="noticias-container">
      <div className="noticias-inner">
        {/* Header */}
        <div className="noticias-header">
          <div className="noticias-title-section">
            <h2 className="noticias-title">
              <span className="noticias-title-desktop">Notícias</span>
              <span className="noticias-title-mobile">Notícias</span>
            </h2>

            {/* Link Ver Todas - movido para baixo do título */}
            <div className="noticias-see-all-wrapper">
              <a
                href="../acontece-na-forluz/noticias"
                className="noticias-see-all"
              >
                <span>Acessar todas as notícias</span>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.172 7.00017L6.808 1.63617L8.222 0.222168L16 8.00017L8.222 15.7782L6.808 14.3642L12.172 9.00017H0V7.00017H12.172Z"
                    fill="currentColor"
                  />
                </svg>
              </a>
            </div>
          </div>

          {/* Swiper de Notícias */}
          <div className="noticias-content">
            <NoticiaSwiper noticias={noticias} swiperIndex={swiperIndex} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Noticias;
